
document.addEventListener('DOMContentLoaded', function () {
  const isWatchesCollection = window.location.pathname === '/collections/buy-1-get-2-free-watches';

  if (!isWatchesCollection) return;
  if (document.querySelector('.bogo-floating-reminder')) return;

  const reminder = document.createElement('div');
  reminder.className = 'bogo-floating-reminder';
  reminder.innerHTML = `
    <div class="bogo-floating-reminder__inner">
      <button type="button" class="bogo-floating-reminder__toggle" aria-haspopup="dialog" aria-controls="bogo-deal-modal">
        <div class="bogo-floating-reminder__main">
          <span class="bogo-floating-reminder__label">Today's Deal</span>
          <strong>Add 3 watches. Pay for 1.</strong>
        </div>
        <span class="bogo-floating-reminder__arrow">↑</span>
      </button>
    </div>
  `;

  const modal = document.createElement('div');
  modal.className = 'bogo-deal-modal';
  modal.id = 'bogo-deal-modal';
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML = `
    <div class="bogo-deal-modal__overlay" data-close-modal></div>

    <div class="bogo-deal-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="bogo-deal-modal-title">
    

      <div class="bogo-deal-modal__content">
        <p class="bogo-deal-modal__eyebrow">Today's Deal</p>
        <h3 class="bogo-deal-modal__title" id="bogo-deal-modal-title">How the Promo works</h3>

        <div class="bogo-deal-modal__steps">
          <div class="bogo-deal-step">
            <div class="bogo-deal-step__icon">
              <span>✓</span>
            </div>
            <div class="bogo-deal-step__text">
              <strong>Step 1:</strong> Add any 3 watches to your cart. Pay for 1 only.
            </div>
          </div>

          <div class="bogo-deal-step">
            <div class="bogo-deal-step__icon">
              <span>✓</span>
            </div>
            <div class="bogo-deal-step__text">
              <strong>Step 2:</strong> Discount appears automatically when the 3rd watch is added.
            </div>
          </div>
        </div>

        <button type="button" class="bogo-deal-modal__cta" data-close-modal>
          Choose watches
        </button>
      </div>
    </div>
  `;

  document.body.appendChild(reminder);
  document.body.appendChild(modal);

  const toggleReminderVisibility = () => {
    if (window.scrollY > 500) {
      reminder.classList.add('is-visible');
    } else {
      reminder.classList.remove('is-visible');
    }
  };

  const reminderButton = reminder.querySelector('.bogo-floating-reminder__toggle');
  const closeTargets = modal.querySelectorAll('[data-close-modal]');

  const openModal = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bogo-modal-open');
    document.body.classList.add('bogo-modal-open');
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bogo-modal-open');
    document.body.classList.remove('bogo-modal-open');
  };

  reminderButton.addEventListener('click', function () {
    openModal();
  });

  closeTargets.forEach((element) => {
    element.addEventListener('click', function () {
      closeModal();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  window.addEventListener('scroll', toggleReminderVisibility, { passive: true });
  toggleReminderVisibility();
});